import _ from "underscore";
import { MobileActions } from "../../store/mobile/actions";
import pageHTML from "./errors.tmpl";
import DebugPageView from "./debugPageView";

export default class ErrorsView extends DebugPageView {
    private readonly template = _.template(pageHTML);

    /* eslint-disable @typescript-eslint/unbound-method */
    events () {
        return {
            "click #throwStandardError": this.throwStandardError,
            "click #throwUnhandledPromise": this.throwUnhandledPromise
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */


    render () {
        this.el.innerHTML = this.template();

        this.app.store.dispatch(MobileActions.setPageState({
            title: "Errors Debug",
            pageLevel: 2
        }));

        return this;
    }

    /**
     * Manual test for standard error reporting
     * Either test in production, or enable error tracker locally
     * Make sure that random session is replaced with ***** in error tracker
     */
    throwStandardError () {
        this.el.querySelector("#throwStandardError").disabled = true;
        const STACK_DEPTH = Math.floor(Math.random() * 10) + 5;
        const innerStacktraceFunction = (num = STACK_DEPTH) => {
            if (num === 0) {
                throw new Error(`Test standard error. SessionId: '${ Math.random().toString().slice(2, 11) }' `);
            }
            innerStacktraceFunction(num - 1);
        };
        try {
            innerStacktraceFunction();
        } finally {
            this.el.querySelector("#throwStandardError").disabled = false;
        }
    }

    promiseToNotHandle = (myNumber: Number, doItRight = false) => new Promise((resolve, reject) => {
        if (myNumber !== -1) {
            if (doItRight) {
                reject(new Error("Test UnhandledRejection. SessionId: '987987987' "));
            } else {
                // If we don't reject using an Error object, we can't log the stack trace on error tracker.
                reject("Test UnhandledRejection. SessionId: '987987987' ");
            }
            return;
        }
        resolve("Congrats, you made it! :)");
    });

    throwUnhandledPromise () {
        let myResult = this.promiseToNotHandle(0, true).then(result => {
            return result;
        });

        // You shouldn't void your promises! But if you do, i've got it covered B)
        void myResult;
    }
}